import React, { Component, Fragment } from 'react';
import { stringify, parse } from 'query-string';
import { Button, Col, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import Card from '../../../../components/Card/Card';

import { connect } from 'react-redux';
import { object, func } from 'prop-types';
import {
  startSetOffers,
  startSearchOffers,
  setOffersCatalogFilter,
} from '../../../../actions/offers';
import OffersFilter from '../../../../components/Offers/OffersFilter/OffersFilter';
import OffersSearch from '../../../../components/Offers/OffersSearch';

class OffersFilters extends Component {
  constructor(props) {
    super(props);
    const parsedParams = parse(window.location.search);
    this.state = {
      query: parsedParams.search ? parsedParams.search : '',
      filters: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.catalogFilters && nextProps.catalogFilters.length !== this.state.filters.length) {
      this.setState(() => ({
        filters: nextProps.catalogFilters,
      }));
    }
  }

  prepareParamsForURL = (params = {}) => {
    return Object.keys(params).reduce((parsed, key) => {
      const param = params[key];

      if (param !== undefined && Array.isArray(param)) {
        return { ...parsed, [key]: param.length > 0 ? param.join(',') : undefined };
      }

      return parsed;
    }, {});
  };

  setFiltersURL = params => {
    const parsed = this.prepareParamsForURL(params);
    const parsedParams = parse(window.location.search);
    if (parsedParams.search) {
      parsed.search = parsedParams.search;
    }

    history.replaceState(
      {},
      null,
      window.location.pathname + '?' + stringify(parsed, { encode: false }),
    );
  };

  handleChange = e => {
    const query = e.target.value;

    this.setState(
      () => ({ query }),
      () => {
        const { query } = this.state;
        this.props.onSearch(query);
      },
    );
  };

  isFilterNotEmpty = name => this.props.filters[name].length;

  filtersReset = () => {
    this.setState(
      () => ({
        query: '',
        filters: [],
      }),
      () => {
        this.props.onFiltersReset();
      },
    );
  };

  filtersApply = () => {
    this.props.setOffersCatalogFilter(this.state.filters);

    this.setFiltersURL({
      ...this.state.filters,
    });
  };

  handleFilterChange = data => {
    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        ...data,
      },
    }));
  };

  getAmount = type => {
    const { filters } = this.state;
    return filters[type] ? filters[type].length : 0;
  };

  render() {
    const { query } = this.state;
    const { filters, loading } = this.props;

    if (!Object.keys(filters).length) return null;

    return (
      <Card
        className="offers-list card-loading-silent"
        loading={loading}
        collapsing={true}
        localStorageName="offersFilters"
      >
        <Card.Header>
          <FormattedMessage id="offers.filters.title" defaultMessage="Filters" />
        </Card.Header>
        <Card.Body>
          <Fragment>
            <div className="offer-filters">
              <Row>
                <Col lg="3">
                  <div className="offers-filter-container">
                    <p className="filter-label">
                      <FormattedMessage
                        id="offers.filters.search.theme_3"
                        defaultMessage="Currencies"
                      />
                    </p>
                    <OffersSearch onChange={this.handleChange} query={query} />
                  </div>
                </Col>
                {this.isFilterNotEmpty('categories') ? (
                  <Col lg="3">
                    <div className="offers-filter-container">
                      <FormattedMessage id="offers.filters.categories" defaultMessage="Categories">
                        {label => (
                          <Fragment>
                            <p className="filter-label">{label}</p>
                            <OffersFilter
                              name="categories"
                              defaultLabel={label}
                              items={filters.categories}
                              onUpdate={this.handleFilterChange}
                              amount={this.getAmount('categories')}
                              search
                            />
                          </Fragment>
                        )}
                      </FormattedMessage>
                    </div>
                  </Col>
                ) : null}
                {this.isFilterNotEmpty('countries') ? (
                  <Col lg="3">
                    <div className="offers-filter-container">
                      <FormattedMessage
                        id="offers.filters.countries.theme_3"
                        defaultMessage="Countries"
                      >
                        {label => (
                          <Fragment>
                            <p className="filter-label">{label}</p>
                            <OffersFilter
                              name="countries"
                              defaultLabel={label}
                              items={filters.countries}
                              onUpdate={this.handleFilterChange}
                              amount={this.getAmount('countries')}
                              search
                            />
                          </Fragment>
                        )}
                      </FormattedMessage>
                    </div>
                  </Col>
                ) : null}
                {this.isFilterNotEmpty('currencies') ? (
                  <Col lg="3">
                    <div className="offers-filter-container">
                      <FormattedMessage
                        id="offers.filters.currencies.theme_3"
                        defaultMessage="Currencies"
                      >
                        {label => (
                          <Fragment>
                            <p className="filter-label">{label}</p>
                            <OffersFilter
                              name="currencies"
                              defaultLabel={label}
                              items={filters.currencies}
                              onUpdate={this.handleFilterChange}
                              amount={this.getAmount('currencies')}
                            />
                          </Fragment>
                        )}
                      </FormattedMessage>
                    </div>
                  </Col>
                ) : null}
                {/*{this.isFilterNotEmpty('approved') ? (*/}
                {/*  <Col lg="3">*/}
                {/*    <div className="offers-filter-container">*/}
                {/*      <FormattedMessage*/}
                {/*        id="offers.filters.sources.theme_3"*/}
                {/*        defaultMessage="Sources"*/}
                {/*      >*/}
                {/*        {label => (*/}
                {/*          <Fragment>*/}
                {/*            <p className="filter-label">{label}</p>*/}
                {/*            <OffersFilter*/}
                {/*              name="sources"*/}
                {/*              defaultLabel={label}*/}
                {/*              items={filters.approved}*/}
                {/*              onUpdate={this.handleFilterChange}*/}
                {/*              search*/}
                {/*              className="offers_filters_sources"*/}
                {/*              amount={this.getAmount('sources')}*/}
                {/*            />*/}
                {/*          </Fragment>*/}
                {/*        )}*/}
                {/*      </FormattedMessage>*/}
                {/*    </div>*/}
                {/*  </Col>*/}
                {/*) : null}*/}
              </Row>
            </div>
          </Fragment>
        </Card.Body>
        <Card.Footer>
          <div className="text-right">
            <Button color="primary" onClick={this.filtersApply}>
              <FormattedMessage id="main.apply" defaultMessage="Apply" />
            </Button>
            <Button color="primary" outline onClick={this.filtersReset}>
              <FormattedMessage id="offers.filters.reset" defaultMessage="Reset" />
            </Button>
          </div>
        </Card.Footer>
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  filters: state.offers.filters,
  catalogFilters: state.offers.catalogFilters,
});

const mapDispatchToProps = dispatch => ({
  startSearchOffers: params => dispatch(startSearchOffers(params)),
  startSetOffers: () => dispatch(startSetOffers()),
  setOffersCatalogFilter: checked => dispatch(setOffersCatalogFilter(checked)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OffersFilters);
